<div class="container lastest-posts">
  <div>
    <header>
      <h2 class="text-orange">Últimas postagens</h2>
    </header>

    <div class="row">
      <div class="col-md-4" *ngFor="let post of latestPosts; index as i">
        <div class="post">
          <img
            class="img-fluid"
            [src]="env.origin + '/blogmidias/' + post.postId + '.jpg'"
            [alt]="post.altImg"
          />
          <div class="container-category-data">
            <div class="d-flex">
              <!-- <span class="categoria">{{ post.category[0] }}</span>
              <span *ngIf="post.category.length > 1" class="categoria count">
                {{ '+' + (post.category.length - 1) }}
              </span> -->
            </div>
            <span class="data">{{ parseDate(post.date) | date:'dd/MM/yyyy' }}</span> 
          </div>
          <p>
            <a target="_blank"
              style="color: #0060af; font-size: 1.25rem"
              [attr.href]="['/blog/' + post.postId]"
              >{{ post.title }}</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
